export default "__VITE_ASSET__34621b34__"